import React, { PropsWithChildren } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
} from "@mui/material";
import { Typography } from "@platform/design-system";
import { ArrowDropDown } from "@mui/icons-material";

type Props = PropsWithChildren<{
  name: string;
}>;

const TrackerCard: React.FC<Props> = ({ name, children }) => (
  <Accordion
    defaultExpanded
    sx={{
      boxShadow: "none",
      border: 1,
      borderColor: "neutrals.neutral_300",
    }}
  >
    <AccordionSummary
      expandIcon={<ArrowDropDown />}
      sx={{ background: "#E6F2FA", flexDirection: "row-reverse", gap: 1.25 }}
    >
      <Typography component="span">{name}</Typography>
    </AccordionSummary>
    <AccordionDetails sx={{ padding: 3 }}>
      <Box mt={3} ml={2}>
        {children}
      </Box>
    </AccordionDetails>
  </Accordion>
);

export default TrackerCard;
